/* eslint-disable max-lines */
/* eslint-disable max-len */

export function ContentLocaleSw() {
  return (
    <>
      <div>
        <p className="page-title">
          Datenschutzerklärung des Robotics Web Portal
        </p>
        <h2 className="heading-title">
          I. Name und Anschrift des Verantwortlichen und des
          Datenschutzbeauftragten
        </h2>

        <p className="my-20">Name und Kontaktdaten des Verantwortlichen:</p>
        <p>Kärcher AG</p>
        <p>Geschäftsführer Karl Steiner</p>
        <p>Industriestrasse 16</p>
        <p>8108 Dällikon</p>
        <p>Tel.: +41 844 850 863</p>
        <p>
          <a href="mailto:info@ch.kaercher.com">info@ch.kaercher.com</a>
        </p>

        <p className="my-10">
          (nachfolgend: Kärcher) verfährt bei allen Vorgängen der
          Datenverarbeitung (z. B. Erhebung, Verarbeitung und Übermittlung) nach
          den gesetzlichen Vorschriften.
        </p>

        <p className="my-10">
          Die nachfolgende Erklärung gibt Ihnen einen Überblick darüber, welche
          Art von Daten auf und über unser Web Portal unter&nbsp;
          <a
            href="https://kira-webportal.ipp.kaercher.com/"
            target="_blank"
            rel="noreferrer noopener">
            https://kira-webportal.ipp.kaercher.com/
          </a>
          &nbsp;(nachfolgend: Plattform) erhoben und in welcher Weise
          verarbeitet werden, welche Sicherheitsmassnahmen Kärcher zum Schutz
          Ihrer Daten ergreift und wie Sie Ihre Rechte wahrnehmen können.
        </p>

        <p className="my-10">
          Bei Fragen zum Thema Datenschutz, und hinsichtlich Ihrer Rechte als
          betroffene Person erreichen Sie den Kärcher-Datenschutzbeauftragten
          unter:
        </p>

        <p>Kärcher AG</p>
        <p>Datenschutzbeauftragter</p>
        <p>Industriestrasse 16</p>
        <p>8108 Dällikon</p>
        <p>
          <a href="mailto:online@ch.kaercher.com">online@ch.kaercher.com</a>
        </p>
      </div>

      <div className="mt-40">
        <h2>II. Allgemeines zur Datenverarbeitung</h2>

        <h3>1. Umfang der Verarbeitung personenbezogener Daten</h3>
        <p>
          Soweit nicht anders angegeben, verarbeiten wir Ihre personenbezogenen
          Daten als Nutzer unserer Plattform (nachfolgend: Betroffener), um
          Ihnen eine funktionsfähige und nutzerfreundliche Plattform sowie
          unsere jeweiligen Dienste bereitstellen und erbringen zu können.
        </p>

        <h3>2. Rechtsgrundlage für die Verarbeitung personenbezogener Daten</h3>
        <p>
          Soweit wir für Verarbeitungsvorgänge personenbezogener Daten eine
          Einwilligung der betroffenen Person einholen, dient Art. 6 Abs. 1 lit.
          a Datenschutzgrundverordnung (DSGVO) als Rechtsgrundlage.
        </p>

        <p className="mt-10">
          Bei der Verarbeitung von personenbezogenen Daten, die zur Nutzung der
          Plattform erforderlich ist, dient Art. 6 Abs. 1 lit. b DSGVO als
          Rechtsgrundlage. Dies gilt auch für Verarbeitungsvorgänge, die zur
          Durchführung vorvertraglicher Maßnahmen erforderlich sind.
        </p>
        <p>
          Soweit eine Verarbeitung personenbezogener Daten zur Erfüllung einer
          rechtlichen Verpflichtung erforderlich ist, der unser Unternehmen
          unterliegt, dient Art. 6 Abs. 1 lit. c DSGVO als Rechtsgrundlage.
        </p>

        <p className="mt-10">
          Ist die Verarbeitung zur Wahrung eines berechtigten Interesses unseres
          Unternehmens oder eines Dritten erforderlich und überwiegen die
          Interessen, Grundrechte und Grundfreiheiten des Betroffenen das
          erstgenannte Interesse nicht, so dient Art. 6 Abs. 1 lit. f DSGVO als
          Rechtsgrundlage für die Verarbeitung.
        </p>

        <h3>3. Datenlöschung und Speicherdauer</h3>
        <p>
          Soweit nicht anders angegeben, werden personenbezogenen Daten gesperrt
          oder gelöscht, sobald der Zweck der Speicherung entfällt.
        </p>

        <p className="mt-10">
          Eine Speicherung kann darüber hinaus erfolgen, wenn dies durch den
          europäischen oder nationalen Gesetzgeber in unionsrechtlichen
          Verordnungen, Gesetzen oder sonstigen Vorschriften, denen der
          Verantwortliche unterliegt, vorgesehen wurde. Eine Sperrung oder
          Löschung der Daten erfolgt auch dann, wenn eine so vorgeschriebene
          Speicherfrist abläuft, es sei denn, dass eine Erforderlichkeit zur
          weiteren Speicherung der Daten für einen Vertragsabschluss oder eine
          Vertragserfüllung besteht.
        </p>
      </div>

      <div className="mt-40">
        <h2>III. Bereitstellung der Plattform</h2>

        <h3>1. Beschreibung und Umfang der Datenverarbeitung</h3>
        <p>
          Bei jedem Aufruf unserer Plattform erfasst unser System automatisiert
          Daten und Informationen vom Computersystem des aufrufenden Rechners.
        </p>

        <p className="mt-10">Folgende Daten werden hierbei erhoben:</p>

        <ul>
          <li>Datum und Uhrzeit der Anforderung</li>
          <li>Name der angeforderten Datei</li>
          <li>Zeitpunkt des letzten Logins</li>
          <li>Seite, von der aus die Datei angefordert wurde</li>
          <li>Zugriffsstatus (Datei übertragen, Datei nicht gefunden, etc.)</li>
          <li>verwendeter Webbrowser und verwendetes Betriebssystem</li>
          <li>vollständige IP-Adresse des anfordernden Rechners</li>
          <li>übertragene Datenmenge</li>
          <li>Robotik-Daten, Roboter-Routeninformationen und -Karten</li>
        </ul>

        <p>
          Die Daten werden ebenfalls in den Logfiles unseres Systems
          gespeichert.
        </p>

        <h3>2. Rechtsgrundlage für die Datenverarbeitung</h3>
        <p>
          Rechtsgrundlage für die vorübergehende Speicherung der Daten und der
          Logfiles ist Art. 6 Abs. 1 lit. f DSGVO.
        </p>

        <h3>3. Zweck der Datenverarbeitung</h3>
        <p>
          Die vorübergehende Speicherung der IP-Adresse durch das System ist
          notwendig, um eine Auslieferung der Plattform an den Rechner des
          Nutzers zu ermöglichen. Hierfür muss die IP-Adresse des Nutzers für
          die Dauer der Sitzung gespeichert bleiben.
        </p>

        <p className="mt-10">
          Die Speicherung in Logfiles erfolgt, um die Funktionsfähigkeit der
          Plattform sicherzustellen. Zudem dienen uns die Daten zur Optimierung
          der Plattform und zur Sicherstellung der Sicherheit unserer
          informationstechnischen Systeme.
        </p>

        <p className="mt-10">
          In diesen Zwecken liegt auch unser berechtigtes Interesse an der
          Datenverarbeitung nach Art. 6 Abs. 1 lit. f DSGVO.
        </p>

        <h3>4. Dauer der Speicherung</h3>
        <p>
          Die Daten werden gelöscht, sobald sie für die Erreichung des Zweckes
          ihrer Erhebung nicht mehr erforderlich sind.
        </p>
      </div>

      <div className="mt-40">
        <h2>IV. Registrierung auf der Plattform</h2>

        <h3>1. Beschreibung und Umfang der Datenverarbeitung</h3>
        <p>
          Um die Plattform umfassend nutzen und die für das/die jeweils
          angemeldete(n) Geräte verarbeiteten Maschinendaten abrufen zu können,
          ist eine Registrierung auf der Plattform und Anmeldung eines
          Nutzerkontos zwingend erforderlich.
        </p>

        <p className="mt-10">
          Die Registrierung eines Nutzerkontos erfolgt über einen Kärcher
          Account, bei dem der jeweilige Nutzer zusammen mit Ihrer
          E-Mail-Adresse ein Passwort (nachfolgend: Benutzerdaten) wählen
          können. Zusätzlich können weitere freiwillige Angaben (z.B. Firmenname
          und Kontaktdaten) gemacht werden. Die Daten werden dabei in eine
          Eingabemaske eingegeben und an uns übermittelt und gespeichert.
        </p>

        <p className="mt-10">
          Für die Weiterleitung von Mitteilungen per SMS oder E-Mail, die von
          einem Gerät versendet werden, können Telefonnummern und
          E-Mail-Adressen auf der Plattform hinterlegt. Diese werden als
          sogenannte Operator gespeichert, bei dem Name, Telefonnummer,
          E-Mail-Adresse und das jeweilige Gerät gespeichert wird von dem die
          Mitteilungen weitergeleitet werden.
        </p>

        <h3>2. Rechtsgrundlage für die Datenverarbeitung</h3>
        <p>
          Rechtsgrundlage der Verarbeitung der personenbezogenen Daten ist die
          Vertragserfüllung (Art. 6 Abs. 1 lit. b DSGVO).
        </p>

        <h3>3. Zweck der Datenverarbeitung</h3>
        <p>
          Die Anlage eines Nutzerkontos ist für die Zuordnung zu dem jeweiliger
          Gerät bzw. der Nutzung der bereitgestellten Funktionen erforderlich.
          Die Daten werden gegebenenfalls also auch beim Einsatz der von dem
          Nutzer ausgewählten Funktionen verarbeitet.
        </p>

        <h3>4. Dauer der Speicherung</h3>
        <p>
          Bei Anlage eines Nutzerkontos speichern wir die jeweils angegebenen
          personenbezogenen Daten grundsätzlich solange Sie Ihr Nutzerkonto
          aufrechterhalten bzw. in dem Nutzerkonto nicht geändert oder gelöscht
          werden.
        </p>

        <p className="mt-10">
          Bitte beachten Sie, dass eine Löschung des jeweiligen Nutzerkontos auf
          der Plattform ggf. den Verlust des Zugriffs auf die Plattform und den
          Zugriff auf die gespeicherten Daten zur Folge hat.
        </p>

        <h3>5. Löschmöglichkeit</h3>
        <p>
          Nutzer der Plattform haben jederzeit die Möglichkeit, die dort
          gespeicherten personenbezogenen Daten zu ändern bzw. diesen selbst
          wieder zu löschen.
        </p>

        <p className="mt-10">
          Sind die Daten zur Erfüllung eines Vertrages oder zur Durchführung
          vorvertraglicher Maßnahmen erforderlich, ist eine vorzeitige Löschung
          der Daten nur möglich, soweit nicht vertragliche oder gesetzliche
          Verpflichtungen einer Löschung entgegenstehen.
        </p>
      </div>

      <div className="mt-40">
        <h2>V. Verwendung von Cookies</h2>

        <h3>1. Beschreibung und Umfang der Datenverarbeitung</h3>
        <p>
          Unsere Plattform verwendet Cookies. Bei Cookies handelt es sich um
          Textdateien, die im Internetbrowser bzw. vom Internetbrowser auf dem
          Computersystem des Nutzers gespeichert werden. Ruft ein Nutzer eine
          Plattform auf, so kann ein Cookie auf dem Betriebssystem des Nutzers
          gespeichert werden. Dieser Cookie enthält eine charakteristische
          Zeichenfolge, die eine eindeutige Identifizierung des Browsers beim
          erneuten Aufrufen der Plattform ermöglicht.
        </p>

        <h3>2. Rechtsgrundlage für die Datenverarbeitung</h3>
        <p>
          Die Rechtsgrundlage für die Verarbeitung personenbezogener Daten unter
          Verwendung funktional oder technisch notwendiger Cookies ist Art. 6
          Abs. 1 lit. f DSGVO.
        </p>

        <h3>3. Zweck der Datenverarbeitung</h3>
        <p>
          Der Zweck der Verwendung technisch notwendiger Cookies ist, die
          Nutzung von Plattform für die Nutzer zu vereinfachen. Einige
          Funktionen unserer Plattform können ohne den Einsatz von Cookies nicht
          angeboten werden. Die durch technisch notwendige Cookies erhobenen
          Nutzerdaten werden nicht zur Erstellung von Nutzerprofilen verwendet.
          In diesen Zwecken liegt auch unser berechtigtes Interesse in der
          Verarbeitung der personenbezogenen Daten nach Art. 6 Abs. 1 lit. f
          DSGVO.
        </p>

        <h3>4. Widerspruchsmöglichkeit</h3>
        <p>
          Cookies werden auf dem Rechner des Nutzers gespeichert und von diesem
          an unsere Seite übermittelt. Daher haben Sie als Nutzer auch die volle
          Kontrolle über die Verwendung von Cookies. Durch eine Änderung der
          Einstellungen in Ihrem Internetbrowser können Sie die Übertragung von
          Cookies deaktivieren oder einschränken. Bereits gespeicherte Cookies
          können jederzeit gelöscht werden. Dies kann auch automatisiert
          erfolgen. Werden Cookies für unsere Plattform deaktiviert, können
          möglicherweise nicht mehr alle Funktionen der Plattform vollumfänglich
          genutzt werden.
        </p>
      </div>

      <div className="mt-40">
        <h2>VI. Weitergabe an Dritte</h2>

        <p>
          Innerhalb der Kärcher Unternehmensgruppe tauschen wir personenbezogene
          Daten konzernintern aus, sofern und soweit dies zur Vertragsabwicklung
          oder zur Durchführung vorvertraglicher Maßnahmen gemäß Art. 6 Abs.1
          lit.b DSGVO erforderlich ist oder sich ein berechtigtes Interesse
          gemäß Art. 6 Abs. 1 lit. f DSGVO an einer konzerninternen Weitergabe
          ergibt.
        </p>

        <p className="mt-10">
          Eine Weitergabe Ihrer personenbezogenen Daten an Dritte erfolgt ohne
          Ihre ausdrückliche vorherige Einwilligung neben den explizit in dieser
          Datenschutzerklärung genannten Fällen lediglich dann, wenn es
          gesetzlich zulässig bzw. erforderlich ist.
        </p>

        <p className="mt-10">
          Wenn es zur Aufklärung einer rechtswidrigen bzw. missbräuchlichen
          Nutzung der Plattform oder für die Rechtsverfolgung erforderlich ist,
          werden personenbezogene Daten an die Strafverfolgungsbehörden oder
          andere Behörden sowie ggf. an geschädigte Dritte weitergeleitet. Dies
          geschieht jedoch nur, wenn Anhaltspunkte für ein gesetzwidriges bzw.
          missbräuchliches Verhalten vorliegen. Wir sind zudem gesetzlich
          verpflichtet, auf Anfrage bestimmten öffentlichen Stellen Auskunft zu
          erteilen. Dies sind Strafverfolgungsbehörden, Behörden, die
          bußgeldbewährte Ordnungswidrigkeiten verfolgen, und die
          Finanzbehörden.
        </p>

        <p className="mt-10">
          Eine etwaige Weitergabe der personenbezogenen Daten ist dadurch
          gerechtfertigt, dass (1) die Verarbeitung zur Erfüllung einer
          rechtlichen Verpflichtung erforderlich ist, der wir gemäß Art. 6 Abs.
          1 lit. c DSGVO i.V.m. nationalen rechtlichen Vorgaben zur Weitergabe
          von Daten an Strafverfolgungsbehörden unterliegen, oder (2) wir ein
          berechtigtes Interesse daran haben, die Daten bei Vorliegen von
          Anhaltspunkten für missbräuchliches Verhalten oder zur Durchsetzung
          von Rechtsansprüchen an die genannten Dritten weiterzugeben und Ihre
          Rechte und Interessen am Schutz Ihrer personenbezogenen Daten im Sinne
          von Art. 6 Abs. 1 lit. f DSGVO nicht überwiegen.
        </p>

        <p className="mt-10">
          Um die Dienste auf dieser Plattform anbieten zu können, werden
          Fremdunternehmen und externe Dienstleister eingesetzt. Etwaige
          eingesetzte Fremdunternehmen und externen Dienstleister werden im
          Rahmen von Art. 28 Abs. 1 DSGVO als Auftragsverarbeiter sorgfältig
          ausgewählt, regelmäßig überprüft und vertraglich verpflichtet,
          sämtliche personenbezogenen Daten ausschließlich entsprechend unserer
          Weisungen zu verarbeiten.
        </p>
      </div>

      <div className="mt-40">
        <h2>VII. Datenübermittlung in Drittländer</h2>

        <p>
          Soweit nicht anders angegeben, findet eine Datenübermittlung an
          Stellen in Staaten außerhalb der Europäischen Union (sogenannte
          Drittstaaten) nur statt, soweit
        </p>

        <ul>
          <li>
            es zur Ausführung Ihrer Aufträge erforderlich ist (z. B.
            Zahlungsaufträge),
          </li>
          <li>es zur Produktverbesserung dient,</li>
          <li>ein angemessenes Datenschutzniveau sichergestellt ist oder</li>
          <li>Sie uns Ihre Einwilligung erteilt haben.</li>
        </ul>
      </div>

      <div className="mt-40">
        <h2>VIII. Datensicherheit</h2>

        <h3>1. Allgemeine technisch organisatorische Maßnahmen</h3>
        <p>
          Kärcher hat eine Vielzahl von Sicherheitsmaßnahmen ergriffen, um
          personenbezogene Informationen im angemessenen Umfang und adäquat zu
          schützen. Alle bei Kärcher gespeicherten Daten werden durch physische
          und technische Maßnahmen sowie Verfahrensmaßnahmen geschützt, die den
          Zugang zu den Informationen auf speziell autorisierte Personen in
          Übereinstimmung mit dieser Datenschutzerklärung einschränken.
        </p>

        <h3>2. Sichere Datenübertragung</h3>
        <p>
          Die Übertragung Ihrer persönlichen Daten im Rahmen eines
          Bestellvorgangs erfolgt verschlüsselt unter Nutzung des
          Industrie-Standards Secure-Socket-Layer („SSL“)-Technologie,
          SSL-Verschlüsselung Version oder vergleichbaren Technologien.
        </p>

        <h3>3. Passwörter</h3>
        <p>
          Ihr Passwort für den Zugang zu unserer Plattform sollten Sie niemals
          an Dritte weitergeben und es auch regelmäßig ändern. Wenn Sie Ihr
          Nutzerkonto verlassen wollen, sollten Sie das Logout betätigen und
          Ihren Browser schließen, um zu vermeiden, dass jemand unberechtigt
          Zugang dazu erlangt.
        </p>
      </div>

      <div className="mt-40">
        <h2>IX. Rechte der betroffenen Person</h2>

        <h3>1. Recht auf Auskunft</h3>
        <p>
          Sie können Auskunft nach Art. 15 DSGVO über Ihre personenbezogenen
          Daten verlangen, die wir verarbeiten.
        </p>

        <h3>2. Recht auf Widerspruch:</h3>
        <p>
          Sie haben ein Recht auf Widerspruch aus besonderen Gründen (siehe
          unter Ziff.8).
        </p>

        <h3>3. Recht auf Berichtigung:</h3>
        <p>
          Sollten die Sie betreffenden Angaben nicht (mehr) zutreffend sein,
          können Sie nach Art. 16 DSGVO eine Berichtigung verlangen. Sollten
          Ihre Daten unvollständig sein, können Sie eine Vervollständigung
          verlangen.
        </p>

        <h3>4. Recht auf Löschung:</h3>
        <p>
          Sie können nach Art. 17 DSGVO die Löschung Ihrer personenbezogenen
          Daten verlangen.
        </p>

        <h3>5. Recht auf Einschränkung der Verarbeitung:</h3>
        <p>
          Sie haben nach Art. 18 DSGVO das Recht, eine Einschränkung der
          Verarbeitung Ihrer personen-bezogenen Daten zu verlangen.
        </p>

        <h3>6. Recht auf Beschwerde:</h3>
        <p>
          Wenn Sie der Ansicht sind, dass die Verarbeitung Ihrer
          personenbezogenen
        </p>
        <p>
          Daten gegen Datenschutzrecht verstößt, haben Sie nach Art. 77 Abs. 1
          DSGVO das Recht, sich bei einer Datenschutzaufsichtsbehörde eigener
          Wahl oder der für die Verantwortliche Stelle zuständigen
          Datenschutzaufsichtsbehörde zu beschweren.
        </p>

        <h3>7. Recht auf Datenübertragbarkeit</h3>
        <p>
          Für den Fall, dass die Voraussetzungen des Art. 20 Abs. 1 DSGVO
          vorliegen, steht Ihnen das Recht zu, sich Daten, die wir auf Grundlage
          Ihrer Einwilligung oder in Erfüllung eines Vertrags automatisiert
          verarbeiten, an sich oder an Dritte aushändigen zu lassen.
        </p>

        <h3>8. Recht auf Widerspruch gemäß Art. 21 Abs. 1 DSGVO:</h3>
        <p>
          Sie haben das Recht, aus Gründen, die sich aus Ihrer besonderen
          Situation ergeben, jederzeit gegen die Verarbeitung Ihrer
          personenbezogenen Daten, die aufgrund von Artikel 6 Abs. 1 lit. f
          DSGVO erfolgt, Widerspruch einzulegen. Der Verantwortliche verarbeitet
          die personen-bezogenen Daten dann nicht mehr, es sei denn, er kann
          zwingende schutzwürdige Gründe für die Verarbeitung nachweisen, die
          die Interessen, Rechte und Freiheiten der betroffenen Person
          überwiegen, oder die Verarbeitung dient der Geltendmachung, Ausübung
          oder Verteidigung von Rechtsansprüchen.
        </p>
      </div>

      <div className="mt-40">
        <h2>X. Änderungen dieser Datenschutzerklärung</h2>

        <p>
          Wir halten diese Datenschutzerklärung immer auf dem neuesten Stand.
          Deshalb behalten wir uns vor, sie von Zeit zu Zeit zu aktualisieren
          und anzupassen und Änderungen bei der Verarbeitung oder Nutzung Ihrer
          Daten nachzupflegen. Die aktuelle Fassung der Datenschutzerklärung ist
          stets unter „Datenschutzerklärung “ innerhalb der Plattform abrufbar.
        </p>
      </div>
    </>
  );
}
